import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "Dialogue",
  icon: "💬",
  templates: [
    {
      title: "Podcast Interview Template",
      content: `Write a podcast-style interview between two speakers.
- Speaker 1 is the host: [a curious and enthusiastic tech journalist].
- Speaker 2 is the guest: [a renowned AI researcher who just published a groundbreaking paper].
- The topic of discussion is [the future of human-AI collaboration in creative fields].
- The tone should be [conversational, insightful, and occasionally humorous].
- Include natural back-and-forth with follow-up questions and anecdotes.

Format each line as "Speaker 1:" or "Speaker 2:" followed by their dialogue.`,
      mode: 'multi'
    },
    {
      title: "Debate Template",
      content: `Write a structured debate between two speakers with opposing viewpoints.
- Speaker 1 argues [in favor of remote work becoming the permanent default].
- Speaker 2 argues [that in-office collaboration is essential for innovation].
- Both speakers should present [well-reasoned arguments with real-world examples].
- The tone should be [respectful but passionate].
- Each speaker should respond directly to the other's points.

Format each line as "Speaker 1:" or "Speaker 2:" followed by their dialogue.`,
      mode: 'multi'
    },
    {
      title: "Language Learning Dialogue Template",
      content: `Write a conversational dialogue between two speakers for language learners.
- The scenario is [ordering food at a busy street market].
- Speaker 1 is [a friendly local vendor recommending their best dishes].
- Speaker 2 is [a traveler trying the local cuisine for the first time].
- Include [natural hesitations, polite phrases, and cultural context].
- The dialogue should feel authentic and help learners with [everyday conversational phrases].

Format each line as "Speaker 1:" or "Speaker 2:" followed by their dialogue.`,
      mode: 'multi'
    }
  ]
};
